
import Component from "vue-class-component"
import MetricTrendWidget from "@/superannuation/MetricTrendWidget.vue"
import PercentOutlineWidget from "@/components/dashboard/PercentOutlineWidget.vue"
import CircularProgressWidget from "@/components/dashboard/CircularProgressWidget.vue"
import IconBannerWidget from "@/components/dashboard/IconBannerWidget.vue"
import SuperScoreProgressWidget from "@/components/dashboard/SuperScoreProgressWidget.vue"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import RetirementAdequacyChart from "@/superannuation/RetirementAdequacyChart.vue"
import DetailPage from "@/superannuation/DetailPage.vue"
import {MetricStore} from "@/cube/metric-data/MetricStore"
import {WithAnalyticsNavigation} from "@/superannuation/WithAnalyticsNavigation"
import HelpIcon from "@/ui/HelpIcon.vue"
import {CampaignService} from "@/CampaignService"

@Component({
  components: {
    HelpIcon,
    DetailPage,
    RetirementAdequacyChart,
    ChangeRateWidget,
    SuperScoreProgressWidget,
    IconBannerWidget,
    CircularProgressWidget,
    PercentOutlineWidget,
    MetricTrendWidget,
  },
})
export default class RetirementAdequacyView extends WithAnalyticsNavigation {
  metricStore: MetricStore

  created() {
    this.metricStore = new MetricStore()
  }

  get contactRequests() {
    return this.metricStore.get(this.$metrics.ContactRequested.countRequests, {
      [this.$cubes.ContactRequestedCube.reason]: "retirementAdequacy",
    })
  }

  get campaigns() {
    return this.metricStore.get(this.$metrics.Campaign.runs, {
      [this.$cubes.CampaignCube.campaignType]: CampaignService.CAMPAIGN_TYPE_REPORT,
    })
  }
}
